import axios from 'axios';
import router from "../router";
import JsSIP, { log } from '../../src/api/jssip-3.6.3.js';
import store from '../../src/store/index.js';
import { markRaw } from 'vue';
const service = axios.create({
	timeout: 500000
});

service.interceptors.request.use(
	config => {
		config.headers.XSecurityVersion = 'v2';
		config.headers.Authorization = localStorage.getItem('token');
		config.headers.UserRole = localStorage.getItem('ms_role');
		config.headers.type = 'web';
		return config;
	},
	error => {
		return Promise.reject();
	}
);
service.interceptors.response.use(
	response => {
		if (response.headers.expiringsoon == 'true') {
			axios({
					url: '/api/login/refreshToken2',
					method: 'post',
					headers: {
						'XSecurityVersion': 'v2',
						'type': 'web',
						'UserRole': localStorage.getItem('ms_role'),
						"Authorization": localStorage.getItem('token')
					}
				})
				.then(function(res) {
					localStorage.setItem('token', 'Bearer ' + res.data.data);
				})
				.catch(function(error) {

				});
		}
		if (response.headers.sipaccount == 'true') {
			axios({
					url: '/api/sipVoice/server?userId=' + localStorage.getItem('user'),
					method: 'get',
					headers: {
						'XSecurityVersion': 'v2',
						'type': 'web',
						'UserRole': localStorage.getItem('ms_role'),
						"Authorization": localStorage.getItem('token')
					}
				})
				.then((res) => {
					if (res.data.code == 200) {
						const socket = new JsSIP.WebSocketInterface('wss://' + res.data.data.fsUrl + ':' + res
							.data.data.sslPort); // 替换为你的 SIP WebSocket 服务器地址
						const ua = markRaw(new JsSIP.UA({
							uri: 'sip:' + res.data.data.account + '@' + res.data.data.ip,
							password: res.data.data.passWord,
							sockets: [socket],
							register: true,
							pcConfig: {
								iceServers: [],
								rtcpMuxPolicy: 'negotiate',
								iceTransportPolicy: 'all',
								bundlePolicy: 'max-bundle',
								codecs: 'PCMU/8000/1,OPUS/48000/2'
							},
						}))
						if (ua) {
							ua.stop();
							store.commit('setCallStatus', '未注册');
							ua.on('connected', () => {
								store.commit('setCallStatus', '注册成功');
							});
						}
						ua.start();
					}
				})
				.catch((error) => {
					console.error('请求错误:', error);
				});
		}
		if (response.status === 200) {
			return response.data;
		} else {
			Promise.reject();
		}
	},
	error => {
		if (error.response) {
			const { status, data } = error.response;
			if (status === 401) {
				console.log(error,'error')
				localStorage.clear();
				window.location.href = '/login';
			} else if (status === 500) {
				console.error('服务器错误:', data);
			}
		} else {
			console.error('网络或请求未完成:', error.message);
		}
		return Promise.reject(error);
	}
);
export default service;